import { blockIsVisible, choiceIsActive, isCheckboxReference, isRadioReference, } from "./templateUtils";
import { isFormControlBlock } from "./formUtils";
/**
 * Scope the field name (tag) for each field array item by it's index.
 * Compute visibility of nested fields and blocks.
 * LIMITATION: the 'visible' json condition on nested fields can refer only to answers from single field array item.
 *
 * @param {Blocks} block The block to index.
 * @param {string} id The ID of the field array.
 * @param {number} index The index of the item in the field array.
 * @param {T} answers The answers for the item.
 * @param {boolean} [isChoiceActive=true] Whether the choice is active.
 * @returns {Blocks} The indexed block.
 */
export const getIndexedBlock = (block, id, index, answers, isChoiceActive = true) => {
    if (isFormControlBlock(block)) {
        const { reference } = block;
        return {
            ...block,
            reference: isCheckboxReference(reference) || isRadioReference(reference)
                ? {
                    ...reference,
                    id: `${id}.${index}.${reference.id}`,
                    choices: reference.choices?.map(choice => choice.children
                        ? {
                            ...choice,
                            children: choice.children.map(block => {
                                return getIndexedBlock(block, id, index, answers, choiceIsActive(reference, answers, choice));
                            }),
                        }
                        : choice),
                }
                : {
                    ...reference,
                    id: `${id}.${index}.${reference.id}`,
                },
            state: {
                ...block.state,
                visible: isChoiceActive && blockIsVisible(answers, block),
            },
        };
    }
    return {
        ...block,
        state: {
            ...block.state,
            visible: isChoiceActive && blockIsVisible(answers, block),
        },
    };
};
/**
 * Get indexed blocks for each of the form values.
 *
 * @param {FieldArrayBlock} field The field array block.
 * @param {FieldArrayValue<T>} [values=[]] The values for the field array.
 * @param {Values} [allValues={}] All the values in the form.
 * @returns {Blocks[]} The indexed blocks.
 */
export const explodeFieldArray = (field, values = [], allValues = {}) => values.flatMap((item, index) => field.children.map(block => getIndexedBlock(block, field.id, index, {
    ...item,
    ...values,
    ...allValues,
})));
